import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Collapse } from "@mui/material";

const EntityConfigSection = (props) => {
    const [ expanded, setExpanded ] = React.useState(props.isExpanded);

    const handleCollapseClick = (event) => {
        if (props.collapsible) {
            setExpanded(!expanded)
        }
    }

    return (
        <div className="grid-x">
            <div className="cell small-12">
                <div
                    className={`entity-config-section-header ${props.collapsible ? 'is-collapsible' : ''} ${expanded ? 'open' : 'closed'}`}
                    onClick={handleCollapseClick}
                >
                    {props.title}

                    { props.tooltip &&
                        <Tooltip title={props.tooltip}>
                            <a className="form-row-tooltip">
                                <i className="fa fa-info-circle"/>
                            </a>
                        </Tooltip>
                    }
                </div>
            </div>

            <div className={`cell small-12 entity-config-section-wrapper`}>
                <Collapse in={expanded} unmountOnExit>
                    <div className={`entity-config-section-body open`}>
                        { props.children }
                    </div>
                </Collapse>
            </div>
        </div>
    )
}

EntityConfigSection.defaultProps = {
    wide: false,
    collapsible: true,
    isExpanded: true,
}

export default EntityConfigSection;
